import { IonCardHeader, IonSkeletonText, withIonLifeCycle } from "@ionic/react";
import React from "react";
import { withTranslation } from "react-i18next";

class CardSkeleton extends React.Component<any, any> {
  render() {
    return (
      <>
        <IonSkeletonText animated style={{ width: "100%", height: this.props.imageHeight || "300px", margin: 0 }} />

        <div className="card__content">
          <IonCardHeader className="card__header">
            <IonSkeletonText animated style={{ width: "80%", height: "24px" }} />
          </IonCardHeader>

          <p>
            <IonSkeletonText animated style={{ width: "100%", height: "1rem" }} />
            <IonSkeletonText animated style={{ width: "80%", height: "1rem" }} />
            <IonSkeletonText animated style={{ width: "90%", height: "1rem" }} />
            <IonSkeletonText animated style={{ width: "100%", height: "1rem" }} />
          </p>
        </div>
      </>
    );
  }
}

const firstHoc = withIonLifeCycle(CardSkeleton);
export default withTranslation()(firstHoc);
